import { CommonModule } from "@angular/common";
import { Injector, NgModule } from "@angular/core";

import { defineCustomElements } from "@dffedb/util";


import { DffedbCookieConsentOverlayComponent } from "./dffedb-cookie-consent-overlay.component";

@NgModule({
    imports: [CommonModule, DffedbCookieConsentOverlayComponent],
    exports: [DffedbCookieConsentOverlayComponent],
    providers: []
})
export class DffedbCookieConsentOverlayModule {
    constructor(injector: Injector) {
        defineCustomElements("dffedb-cookie-consent-overlay", DffedbCookieConsentOverlayComponent, { injector });
    }
}
